import { render, staticRenderFns } from "./NovaPreCotacao.vue?vue&type=template&id=86d586e0&scoped=true&"
import script from "./NovaPreCotacao.vue?vue&type=script&lang=js&"
export * from "./NovaPreCotacao.vue?vue&type=script&lang=js&"
import style0 from "./NovaPreCotacao.vue?vue&type=style&index=0&id=86d586e0&prod&lang=scss&scoped=true&"
import style1 from "./NovaPreCotacao.vue?vue&type=style&index=1&id=86d586e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d586e0",
  null
  
)

export default component.exports